/**
 * 系统模块接口
 * @description 短信、文件上传、APK管理、日志等系统相关接口
 */

import axios from "@/utils/request";
import Api from "../api";
import * as Enum from "../enum";
import * as Request from "../request.type";
import * as ResponseData from "../response.type";

/**
 * 发送短信
 */
export const Http_postSendSms = async (params: Request.SendSmsParams) => {
  /** 清理特定字段的空格和换行，并合并连续逗号 */
  const cleanedData = { ...params };
  const fieldsToProcessCommas: (keyof Pick<
    Request.SendSmsParams,
    "receiverName" | "mobile" | "email" | "orderNo"
  >)[] = ["receiverName", "mobile", "email", "orderNo"];
  for (const key of fieldsToProcessCommas) {
    if (typeof cleanedData[key] === "string") {
      const currentValue = cleanedData[key];
      const items = currentValue
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== "");

      if (items.length > 0) {
        cleanedData[key] = items.join(",");
      } else {
        cleanedData[key] = "";
      }
    }
  }
  return await axios.post(Api.POST_SEND_SMS, cleanedData);
};

/**
 * 短信详情
 */
export const Http_getMessageDetail = async (id: string) => {
  return await axios.get<ResponseData.MessageDetailData>(
    Api.GET_MESSAGE_DETAIL,
    {
      params: {
        id,
      },
    }
  );
};

/**
 * 重发信息
 */
export const Http_postMessageResend = async ({
  id,
  type,
}: {
  /** ID */
  id: string;
  /** 发送类型 0-短信, 1-邮件 */
  type: Enum.MessageType;
}) => {
  return await axios.post<boolean>(Api.POST_MESSAGE_RESEND, {
    messageRecordId: id,
    messageType: type,
  });
};

/**
 * 获取APK列表
 */
export const Http_postApkPageList = async (params: {
  page: number;
  pageSize: number;
}) => {
  return await axios.post<ResponseData.ApkPageListDataType>(
    Api.POST_APK_PAGE_LIST,
    params
  );
};

/**
 * 上传文件
 */
export const Http_postUploadFile = async (formData: FormData) => {
  return await axios.post<{ obsKey: string }>(Api.POST_UPLOAD_FILE, formData, {
    headers: {
      "Content-type": "multipart/form-data",
    },
  });
};

/**
 * 提交apk
 */
export const Http_postUploadApk = async (params: {
  /** 文件key */
  obsKey: string;
  /** 描述 */
  description: string;
  /** 是否强制更新 1-是，0-否 */
  isForce: 1 | 0;
}) => {
  return await axios.post(Api.POST_UPLOAD_APK, params);
};

/**
 * 删除apk
 */
export const Http_postDeleteApk = async (params: { id: number }) => {
  return await axios.post(Api.POST_DELETE_APK, params);
};

/**
 * 更新apk状态
 */
export const Http_postUpdateApkStatus = async (params: {
  id: number;
  status: 1 | 0;
}) => {
  return await axios.post(Api.POST_UPDATE_APK_STATUS, params);
};

/**
 * 上报打印日志
 */
export const Http_postLogForFront = async (params: {
  type: number;
  data: string;
}) => {
  return await axios.post<any>(Api.POST_LOGFORFRONT, params);
};

/**
 * 日志上报接口
 */
export const Http_postLogReport = async (params: {
  /** 日志内容 */
  param: string;
}) => {
  return await axios.post(Api.POST_LOG_FOR_FRONT, params);
};
